export const DEFAULT_VALUES = {
  config: {
    separator: ":",
    orientation: "horizontal",
    placeholder: "-",
    customStyles: {
      label: {},
      value: {},
      placeholder: {},
      container: {}
    }
  },
  data: [],
  id: "label-value-pair"
};

export const VALIDATE_KEY_VALUES = {
  config: true,
  data: true,
  id: true
};
